module.exports = __webpack_public_path__ + "static/Artboard-9-07a51116a4a7c4ba32e9a0a8493503c3.png";